import { OnInit, Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { first } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';
import { CONFIG, UTILS } from 'src/app/core/const/const';
import {Location} from "@angular/common";
import {ToastService} from "../../../shared/components/toast/toast.service";

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
  showError: boolean = false;
  errorMessage!: string;
  isLoader: boolean = false;
  emailInvalid!: boolean;
  user: any;
  @Input() id?: string;

  constructor(
    private _authService: AuthService,
    private _cookies: CookieService,
    private _router: Router,
    private location: Location,
    public toastService: ToastService
  ) {
    this.user = {
      login: '',
      password: '',
      stayLogged: false,
    };
  }

  ngOnInit() {
    let path = this.location.path();
    if(path.search('action=desinscription') > -1 && path.search('done=success') > -1){
      this.toastService.show('Vous avez été désinscrit(e) de notre liste de publipostage.', {
        classname: 'bg-success text-light',
        delay: 10000,
      });
    }
    if(path.search('action=desinscription') > -1 && path.search('done=failed') > -1){
      this.toastService.show('Erreur lors de la désinscription de notre liste de publipostage.', {
        classname: 'bg-danger text-light',
        delay: 10000,
      });
    }
  }

  userLogin(user: any, isMobile: boolean, isInvalid?: any) {
    this.isLoader = true;
    this._authService
      .signIn(user)
      .pipe(first())
      .subscribe({
        next: (response:any) => {
          if (response.code == 202) {
            response = response.data;
            let redirectTo =
              '/espace-personnel/' +
              UTILS.replaceSpace(response.username) +
              '/tableau-de-bord';
            if (response.stayLogged) {

              //response.Expires = new Date('2016-10-06T15:35');
              //this._cookies.remove('Expires');
              this._cookies.set(
                'Expires',
                CONFIG.expiredDate(CONFIG.expiredMinuteTime) + '',
                { path: '/' }
              );
            }

            if (response.otherLoginURL) {
              this.showError = true;
              this.errorMessage = response.message;
            } else {
              // Store in localStorage for large payloads (e.g. users with many delegations)
              localStorage.setItem('user', JSON.stringify(response));
              localStorage.setItem('x-wsse', response.user_token);
              // Set cookies for legacy support
              this._cookies.set('x-wsse', response.user_token, { path: '/' });
              try {
                this._cookies.set('user', JSON.stringify(response), { path: '/' });
              } catch (e) {}
              this.showError = false;
              this._cookies.set(
                'user_rgpdvalide',
                JSON.stringify(response.rgpdvalide),
                { path: '/' }
              );
              // if (response.rgpdvalide != null) {
              //   let dateRgpd = new Date(response.rgpdvalide);
              //   let dnow = new Date();
              //   if (UTILS.diffdays(dateRgpd, dnow) > 366) {
              //     regpdValidExpired = true;
              //   }
              // }
              //
              // if (
              //   (response.rgpdvalide == null || regpdValidExpired) &&
              //   response.type.id != 5 &&
              //   response.type.id != 9
              // ) {
              //   redirectTo =
              //     '/espace-personnel/' +
              //     UTILS.replaceSpace(response.username) +
              //     '/mes-informations';
              // } else if (response.type.id == 9) {
              //   if (response.first_attempt)
              //     redirectTo =
              //       '/espace-personnel/' +
              //       UTILS.replaceSpace(response.username) +
              //       '/mes-informations';
              //   else
              //     redirectTo =
              //       '/espace-personnel/' +
              //       UTILS.replaceSpace(response.username) +
              //       '/tableau-de-bord';
              // }
              // if (response.type.id == 5) {
              //   redirectTo =
              //     '/espace-personnel/' +
              //     UTILS.replaceSpace(response.username) +
              //     '/tableau-de-bord';
              // }
              redirectTo =
                '/espace-personnel/' +
                UTILS.replaceSpace(response.username) +
                '/tableau-de-bord';
              void this._router.navigateByUrl(redirectTo);
            }
          } else {
            this.showError = true;
            // set errorMessage
            this.errorMessage = response.message;
          }
          this.isLoader = false;
        },
        error: (err) => {
          this.showError = true;
          // set errorMessage
          this.errorMessage = err;
          this.isLoader = false;
        },
      });
  }

  userLogout() {
    void this._router.navigate(['/sign-out']);
  }

  emailCheck(value: any) {
    if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test( // NOSONAR
        value
      )
    ) {
      this.errorMessage = "Votre email n'est pas valide";
      this.showError = true;
    } else {
      this.showError = false;
    }
  }
}
